export default __webpack_public_path__ + "static/thomson_bunker-7588cb52aa6494403e0173a243ebc2d0.png";